import React from 'react';

import Button from '../../../components/ui/Button';

const CalendarHeader = ({
  currentDate,
  viewMode,
  onViewModeChange,
  onPreviousMonth,
  onNextMonth,
  onToday,
}) => {
  const persianMonths = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
  ];

  const formatJalaliDate = (date) => {
    // Mock Jalali conversion - in real app would use moment-jalaali
    const year = 1404;
    const month = Math.floor(Math.random() * 12);
    const day = Math.floor(Math.random() * 29) + 1;

    return {
      year,
      month,
      day,
      monthName: persianMonths?.[month],
    };
  };

  const jalaliDate = formatJalaliDate(currentDate);

  const viewModes = [
    { key: 'day', label: 'روز', icon: 'Calendar' },
    { key: 'week', label: 'هفته', icon: 'CalendarDays' },
    { key: 'month', label: 'ماه', icon: 'CalendarRange' },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Date Navigation */}
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            size="icon"
            onClick={onPreviousMonth}
            iconName="ChevronRight"
            iconSize={20}>
            <span className="sr-only">ماه قبل</span>
          </Button>

          <div className="text-center min-w-[200px]">
            <h2 className="text-xl font-semibold text-foreground">
              {jalaliDate?.monthName} {jalaliDate?.year}
            </h2>
            <p className="text-sm text-muted-foreground">
              امروز: {jalaliDate?.day} {jalaliDate?.monthName}
            </p>
          </div>

          <Button
            variant="outline"
            size="icon"
            onClick={onNextMonth}
            iconName="ChevronLeft"
            iconSize={20}>
            <span className="sr-only">ماه بعد</span>
          </Button>
        </div>

        {/* Quick Actions */}
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onToday}
            iconName="Calendar"
            iconPosition="right">
            امروز
          </Button>

          <Button
            variant="outline"
            size="sm"
            iconName="RotateCcw"
            iconPosition="right">
            بازنشانی
          </Button>
        </div>

        {/* View Mode Selector */}
        <div className="flex items-center bg-muted rounded-lg p-1">
          {viewModes?.map((mode) => (
            <Button
              key={mode?.key}
              variant={viewMode === mode?.key ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange(mode?.key)}
              iconName={mode?.icon}
              iconPosition="right"
              className="min-w-[80px]">
              {mode?.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
